document.addEventListener('DOMContentLoaded', function() {
  
  // Section "Media avec texte" calcule de la largeur du bloc Statistique
  const textWithMediaSections = document.querySelectorAll('.shopify-section--text-with-media');
  
  textWithMediaSections.forEach(section => {
    const statistiques = section.querySelectorAll('.statistique .stat');
    
    if (statistiques.length > 0) {
      let maxWidth = 0;
      
      statistiques.forEach(stat => {
        stat.style.width = 'auto';
      });
      
      statistiques.forEach(stat => {
        const width = stat.offsetWidth;
        if (width > maxWidth) {
          maxWidth = width;
        }
      });
      
      statistiques.forEach(stat => {
        stat.style.width = maxWidth + 'px';
        stat.style.minWidth = maxWidth + 'px';
      });
    }
  });


  // Flèches Judgme 
  if (!!document.querySelector("#judgeme_product_reviews") === true){
    function createArrowNavigation() {
      const reviewsBody = document.querySelector('.jdgm-rev-widg__body');
      const reviewsContainer = document.querySelector('.jdgm-rev-widg__reviews');
      const existingArrows = document.querySelector('.jdgm-arrows-navigation');
      
      // Si les flèches existent déjà, ne pas les recréer
      if (!reviewsBody || !reviewsContainer || existingArrows) return;
      
      // Créer la div conteneur des flèches
      const arrowsContainer = document.createElement('div');
      arrowsContainer.className = 'jdgm-arrows-navigation';
      arrowsContainer.style.cssText = `
        display: flex;
        justify-content: center;
        gap: 10px;
        margin-top: 20px;
        align-items: center;
      `;
      
      // SVG flèche gauche
      const leftArrow = document.createElement('button');
      leftArrow.className = 'jdgm-arrow jdgm-arrow-left';
      leftArrow.innerHTML = `
        <svg width="21" height="32" viewBox="0 0 21 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.4448 28.628L4.89581 16.0682L17.4556 3.51926" stroke="#EEDDC2" stroke-width="6" stroke-linecap="round"/>
        </svg>
      `;
      leftArrow.style.cssText = `
        background: transparent;
        border: none;
        cursor: pointer;
        padding: 10px;
        border-radius: 50%;
      `;
      
      // SVG flèche droite
      const rightArrow = document.createElement('button');
      rightArrow.className = 'jdgm-arrow jdgm-arrow-right';
      rightArrow.innerHTML = `
        <svg width="21" height="32" viewBox="0 0 21 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.55523 3.37202L16.1042 15.9318L3.54443 28.4807" stroke="#EEDDC2" stroke-width="6" stroke-linecap="round"/>
        </svg>
      `;
      rightArrow.style.cssText = `
        background: transparent;
        border: none;
        cursor: pointer;
        padding: 10px;
        border-radius: 50%;
      `;
      
      // Ajouter les flèches au conteneur
      arrowsContainer.appendChild(leftArrow);
      arrowsContainer.appendChild(rightArrow);
      
      // Insérer après .jdgm-rev-widg__body
      reviewsBody.parentNode.insertBefore(arrowsContainer, reviewsBody.nextSibling);
      
      // Configurer le scroll horizontal sur le conteneur des avis
      reviewsContainer.style.cssText = `
        overflow-x: auto;
        scroll-behavior: smooth;
        display: flex;
        gap: 20px;
        padding-bottom: 10px;
        scrollbar-width: none;
        -ms-overflow-style: none;
      `;
      
      // Masquer la scrollbar sur webkit
      const style = document.createElement('style');
      style.textContent = `
        .jdgm-rev-widg__reviews::-webkit-scrollbar {
          display: none;
        }
        .jdgm-rev {
          flex: 0 0 auto;
          min-width: 300px;
        }
      `;
      document.head.appendChild(style);
      
      // Calculer la largeur d'un avis pour le scroll
      function getReviewWidth() {
        const firstReview = reviewsContainer.querySelector('.jdgm-rev');
        if (firstReview) {
          const styles = window.getComputedStyle(firstReview);
          return firstReview.offsetWidth + parseInt(styles.marginRight) + 20; // 20px pour le gap
        }
        return 320; // valeur par défaut
      }
      
      // Fonction de scroll vers la gauche
      function scrollLeft() {
        const scrollAmount = getReviewWidth();
        reviewsContainer.scrollBy({
          left: -scrollAmount,
          behavior: 'smooth'
        });
      }
      
      // Fonction de scroll vers la droite
      function scrollRight() {
        const scrollAmount = getReviewWidth();
        reviewsContainer.scrollBy({
          left: scrollAmount,
          behavior: 'smooth'
        });
      }
      
      // Ajouter les événements de clic
      leftArrow.addEventListener('click', scrollLeft);
      rightArrow.addEventListener('click', scrollRight);
      
      // Forcer un recalcul après un court délai
      setTimeout(() => {
        updateArrowsState();
        // Forcer le recalcul des dimensions
        reviewsContainer.style.display = 'none';
        reviewsContainer.offsetHeight; // Trigger reflow
        reviewsContainer.style.display = 'flex';
      }, 100);
      
      // Fonction pour mettre à jour l'état des flèches
      function updateArrowsState() {
        const isAtStart = reviewsContainer.scrollLeft <= 0;
        const isAtEnd = reviewsContainer.scrollLeft >= (reviewsContainer.scrollWidth - reviewsContainer.clientWidth);
        
        leftArrow.disabled = isAtStart;
        rightArrow.disabled = isAtEnd;
      }
      
      // Mettre à jour l'état initial
      updateArrowsState();
      
      // Écouter les événements de scroll pour mettre à jour l'état des flèches
      reviewsContainer.addEventListener('scroll', updateArrowsState);
      
      // Écouter les changements de taille de fenêtre
      window.addEventListener('resize', updateArrowsState);
    }
    
    // Initialiser les flèches avec un délai pour s'assurer que Judge.me est complètement chargé
    setTimeout(() => {
      createArrowNavigation();
    }, 500);
    
    // Observer les changements DOM au cas où Judge.me rechargerait le contenu
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          const reviewsContainer = document.querySelector('.jdgm-rev-widg__reviews');
          const arrowsContainer = document.querySelector('.jdgm-arrows-navigation');
          
          // Si les avis existent mais pas les flèches, les créer
          if (reviewsContainer && !arrowsContainer) {
            createArrowNavigation();
          }
        }
      });
    });
    
    // Observer le widget Judge.me
    const judgemWidget = document.querySelector('#judgeme_product_reviews');
    if (judgemWidget) {
      observer.observe(judgemWidget, {
        childList: true,
        subtree: true
      });
    }
  }

  setTimeout(() => {
    if (!!document.querySelector("#judgeme_product_reviews .jdgm-rev-widg") === true){
      var note = document.querySelector("#judgeme_product_reviews .jdgm-rev-widg").getAttribute("data-number-of-reviews");
      if ( note == "0" ){
        document.querySelector("#judgeme_product_reviews").closest(".shopify-section--apps").remove();
      }
    }
  }, 1000);


  // Cacher le bouton Smile dans le footer
  const footerElement = document.querySelector('.shopify-section-group-footer-group.shopify-section--footer');
  
  if (footerElement) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (!document.getElementById('smile-hide')) {
            document.head.insertAdjacentHTML('beforeend', '<style id="smile-hide">#gorgias-chat-container,#smile-ui-lite-container{opacity: 0 !important; pointer-events: none;}</style>');
          }
        } else {
          const smileHideStyle = document.getElementById('smile-hide');
          if (smileHideStyle) {
            smileHideStyle.remove();
          }
        }
      });
    }, {
      threshold: 0.1
    });
  
    observer.observe(footerElement);
  }

});

// Détection de l'IP du client avec cookie de session
(function() {
  // Fonction pour lire un cookie
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  // Fonction pour créer un cookie
  function setCookie(name, value, hours = 24) {
    const date = new Date();
    date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
    document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
  }

  function checkCountry() {
    // Vérifier si la redirection a déjà été effectuée
    if (getCookie('country_redirect_done') === 'true') {
      return;
    }

    fetch('https://ipapi.co/json/')
      .then(response => response.json())
      .then(data => {
        const userCountry = data.country_code;
        const currentSelectedButton = document.querySelector('button[name="country_code"][aria-selected="true"]');
        const currentCountry = currentSelectedButton ? currentSelectedButton.value : null;
        
        if (userCountry !== currentCountry) {
          const targetButton = document.querySelector(`button[name="country_code"][value="${userCountry}"]`);
          
          if (targetButton) {
            const returnToInput = document.querySelector('input[name="return_to"]');
            
            if (returnToInput) {
              const currentReturnUrl = returnToInput.value;
              
              const languageMapping = {
                'FR': '/fr',
                'BE': '/fr', 
                'DE': '/en',
                'NL': '/nl',
                'LU': '/fr'
              };
              
              const newPrefix = languageMapping[userCountry];
              
              if (newPrefix) {
                const urlParts = currentReturnUrl.split('?');
                const params = urlParts[1] ? '?' + urlParts[1] : '';
                const newReturnUrl = newPrefix + params;
                
                returnToInput.value = newReturnUrl;
              }
            }
            
            targetButton.click();
          }
        }
        
        // Marquer la redirection comme effectuée (cookie valable 24h)
        setCookie('country_redirect_done', 'true', 24);
      })
      .catch(error => {
        // En cas d'erreur, marquer quand même pour éviter les tentatives répétées
        setCookie('country_redirect_done', 'true', 24);
      });
  }
  
  document.addEventListener("DOMContentLoaded", function() {
    checkCountry();
  });
})();


setTimeout(function () {
  if (!!document.querySelector("#smile-ui-lite-container") === true){
    document.querySelector("#smile-ui-lite-container").style.display = "block";
  }

  if (!!document.querySelector('#gorgias-chat-container') === true){
    document.querySelector('#gorgias-chat-container').style.display = "block";
  }
}, 60000);
